import { render, staticRenderFns } from "./QRLaunch.vue?vue&type=template&id=48e0b5ce&"
import script from "./QRLaunch.vue?vue&type=script&lang=js&"
export * from "./QRLaunch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports